import React from 'react';

interface AvatarProps {
    name: string;
    size?: 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
    variant?: 'default' | 'parent' | 'kid';
}

export const Avatar: React.FC<AvatarProps> = ({ 
    name, 
    size = 'md', 
    className = '',
    variant = 'default'
}) => {
    const getFirstChar = (name: string) => {
        return name.charAt(0).toUpperCase();
    };

    const getSizeClasses = () => {
        switch (size) {
            case 'sm':
                return 'w-8 h-8 text-sm';
            case 'md':
                return 'w-12 h-12 text-lg';
            case 'lg':
                return 'w-16 h-16 text-xl';
            case 'xl':
                return 'w-24 h-24 text-3xl';
            default:
                return 'w-12 h-12 text-lg';
        }
    };

    const getVariantClasses = () => {
        switch (variant) {
            case 'parent':
                return 'bg-amber-100 text-amber-600 border border-amber-200';
            case 'kid':
                return 'bg-indigo-100 text-indigo-600 border border-indigo-200';
            default:
                return 'bg-slate-100 text-slate-600 border border-slate-200';
        }
    };

    return (
        <div 
            className={`
                ${getSizeClasses()} 
                ${getVariantClasses()}
                rounded-full 
                flex 
                items-center 
                justify-center 
                font-black 
                transition-all
                ${className}
            `}
        >
            {getFirstChar(name)}
        </div>
    );
};
